document.addEventListener("DOMContentLoaded", function () {
  var hostname = window.location.hostname;
  var requestOptions = { method: "GET" };
  var mycountry = getCookie("oblicua-country");

  if (hostname != "98125a-7b.myshopify.com") {
    if (mycountry != null) {
      obl_redirect(mycountry);
    } else {
      fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=567965d60ca74d628cda0a399adab550", requestOptions)
        .then(function(response) { return response.json(); })
        .then(function(result) {
          mycountry = result.country.iso_code;
          console.log("Pais detectado: " + mycountry);
          setCookie("oblicua-country", mycountry, 1);
          obl_redirect(mycountry);
        })
        .catch(function(error) { console.log("error", error); });
    }
  }
});

function obl_redirect(country) {
  var host = window.location.hostname;
  var isCO = (host === "benditaseas.co" || host === "www.benditaseas.co");
  var isMX = (host === "mx.benditaseas.com");
  var isES = (host === "es.benditaseas.com");
  var isINT = (host === "int.benditaseas.com");

  switch (country) {
    case "MX":
      if (!isMX) { location.href = "https://mx.benditaseas.com"; }
      break;
    case "CO":
      if (!isCO) { location.href = "https://benditaseas.co"; }
      break;
    case "ES":
      if (!isES) { location.href = "https://es.benditaseas.com"; }
      break;
    default:
      if (!isINT) { location.href = "https://int.benditaseas.com"; }
  }
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") { c = c.substring(1); }
    if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
  }
  return null;
}